import gql from 'graphql-tag'

export const SEGMENTS = gql`
  query Segments($search: String, $page: Int, $pageSize: Int, $sort: [String], $sortDirection: [SortDirection], $isIndustry: Boolean) {
    segments(search: $search, page: $page, pageSize: $pageSize, sort: $sort, sortDirection: $sortDirection, isIndustry: $isIndustry) {
      records
      page
      tags {
        name
        color
      }
      segments {
        _id
        name
        description
        tags {
          name
          color
        }
        version
        clients_qty
        campaign_qty
        created_at
        updated_at
        clients_refreshed_at
      }
    }
  }
`

export const QUERY_A_HUB_ANALYTICS_CONFIGURATIONS = gql`
  query AHubAnalyticsConfigurations(
    $type: aHubAnalyticsConfigurationType!
    $page: Int
    $pageSize: Int
    $sort: [String]
    $sortDirection: [SortDirection]
    $search: String
    $units: [String]
  ) {
    aHubAnalyticsConfigurations(type: $type, page: $page, pageSize: $pageSize, sort: $sort, sortDirection: $sortDirection, search: $search, units: $units) {
      page
      records
      aHubAnalyticsConfigurations {
        _id
        title
        filters {
          units {
            id_erp
            name
          }
        }
        createdAt
      }
    }
  }
`

export const QUERY_GET_A_HUB_ANALYTICS_PERIODS = gql`
  query AHubAnalyticsPeriods(
    $analyticConfigurationsIds: [String]!
    $page: Int
    $pageSize: Int
    $sort: [String]
    $sortDirection: [SortDirection]
    $search: String
    $initialDate: String
    $finalDate: String
  ) {
    aHubAnalyticsPeriods(
      analyticConfigurationsIds: $analyticConfigurationsIds
      page: $page
      pageSize: $pageSize
      sort: $sort
      sortDirection: $sortDirection
      search: $search
      initialDate: $initialDate
      finalDate: $finalDate
    ) {
      page
      records
      aHubAnalyticsPeriods {
        _id
        title
        initialDate
        finalDate
        createdAt
        dynamic
      }
    }
  }
`

export const MUTATION_UPDATE_SEGMENTS = gql`
  mutation RefreshSegments($segments_ids: [ID!]!) {
    refreshSegments(segments_ids: $segments_ids) {
      _id
      clients_qty
      clients_refreshed_at
    }
  }
`

export const QUERY_OFFER_SCHEDULE_SEGMENT = gql`
  query OfferScheduleSegment($segment_id: String!, $_id: String!) {
    offerScheduleSegment(_id: $_id, segment_id: $segment_id) {
      name
      description
      data
      clients_refreshed_at
      segment_clients_quantity
    }
  }
`

export const QUERY_DYNAMIC_ATTRIBUTES = gql`
  query DynamicAttributes {
    dynamicAttributes {
      records
      page
      dynamicAttributes {
        _id
        attribute
        type
        origin
        label
        options {
          label
          value
        }
        last_updated_at
      }
    }
  }
`

export const MUTATION_SEND_PURCHASE_INFO = gql`
  mutation CreateClientsSegmentationPurchaseInfoReport(
    $emails: [String!]!
    $fileFormat: FileFormatType = CSV
    $segmentationId: ID!
    $unitsConfiguration: [UnitConfigurationInput!]!
    $endDate: String!
    $startDate: String!
  ) {
    createClientsSegmentationPurchaseInfoReport(
      emails: $emails
      fileFormat: $fileFormat
      segmentationId: $segmentationId
      unitsConfiguration: $unitsConfiguration
      endDate: $endDate
      startDate: $startDate
    ) {
      fileUrl
    }
  }
`

export const MUTATION_SEND_PURCHASE_PER_UNIT = gql`
  mutation CreateClientsSegmentationPurchasePerUnitReport(
    $emails: [String!]!
    $fileFormat: FileFormatType = CSV
    $segmentationId: ID!
    $unitsConfiguration: [UnitConfigurationInput!]!
    $endDate: String!
    $startDate: String!
  ) {
    createClientsSegmentationPurchasePerUnitReport(
      emails: $emails
      fileFormat: $fileFormat
      segmentationId: $segmentationId
      unitsConfiguration: $unitsConfiguration
      endDate: $endDate
      startDate: $startDate
    ) {
      fileUrl
    }
  }
`

export const SEND_SEGMENTATION_REPORT = gql`
  mutation CreateClientsSegmentationReport(
    $emails: [String!]!
    $groups: [ClientsSegmentationExportGroup!]!
    $segmentationId: ID!
    $fileFormat: FileFormatType
  ) {
    createClientsSegmentationReport(emails: $emails, groups: $groups, segmentationId: $segmentationId, fileFormat: $fileFormat) {
      id
      fileUrl
      payload {
        emails
        groups
        segmentationId
        fileFormat
        __typename
      }
      state
      __typename
    }
  }
`

export const MUTATION_WARMUP_SEGMENTS = gql`
  mutation WarmupSegments($segments_ids: [ID!]!) {
    warmupSegments(segments_ids: $segments_ids)
  }
`
export const MUTATION_LISTIFY_SEGMENTS = gql`
  mutation ListifySegments($segments_ids: [ID!]!) {
    listifySegments(segments_ids: $segments_ids)
  }
`

export const MUTATION_TAGS_SEGMENTS = gql`
  mutation UpdateTagsSegments($data: [SegmentsTagsInput!]!) {
    updateTagsSegments(data: $data)
  }
`

export const QUERY_USER_TAGS = gql`
  query UserTags {
    userTags {
      tag
    }
  }
`
